import React, { Fragment, useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Input, Label } from 'reactstrap';
import { Btn, Alerts } from '../../AbstractElements';
import HeaderCard from '../../Components/Common/Component/HeaderCard';
import { getProject, updateProject  } from '../../Services/Settings.service';
import { useParams } from 'react-router-dom';
import Breadcrumbs from '../../Common/Breadcrumbs';


const EditProject = () => {
    const [name, setName] = useState("");
    const [message, setMessage] = useState("");
    const [showError, setShowError] = useState(false); 
    
    let {id} = useParams()
    const elements = [{'label': 'Projects', 'link': '/Projects'}, {'label': 'Edition du projet', 'link': '/EditProject/'+id}]

    useEffect(() => {
        getProject(id).then((res)=>{
            let result = res[0]
            setName(result.name);
        })
        
    },[])

    const handleSubmit = (e) => {
        e.preventDefault();
        let data = {'name': name}
        updateProject(id, data).then((response) => {
            setMessage(response.message)
            setShowError(true)
        })
    }


    return (
        <Fragment>
            <Breadcrumbs elements={elements} />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <HeaderCard title={`Paramètrage du projet ${name}`}/>
                            <CardBody>
                                <Row>
                                    <Col md="6">
                                    <Form className="theme-form" onSubmit={handleSubmit} >
                                    {showError && (<Alerts attrAlert={{color:'primary '}} children={message} />)}
                                    <FormGroup>
                                        <Label>Libellé</Label>
                                        <Input className="form-control" 
                                                name="name" type="text" required="" 
                                                value={name}
                                                onChange={(e) => {setName(e.target.value)}}/>
                                    </FormGroup>
                                    <FormGroup>
                                        <Btn attrBtn={{ className: 'btn-block', color: 'primary', type: 'submit' }}>Modifier</Btn>
                                    </FormGroup>
                                </Form>
                                    </Col>
                                </Row>
                                
                            </CardBody>
                        </Card>    
                    </Col>
                </Row>
            </Container>
        </Fragment>                
    )

}


export default EditProject;